module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_CIEL_DE_BOIS.d83975af.png";